/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ prefix: NonNullable<unknown>, lastIndex: NonNullable<unknown> }} Image_Export_Summary_Prefix_ScenaristInputs */



/**
* | output |
* | --- |
* | "Prefix: {prefix}.0001.tif → {prefix}.{lastIndex}.tif" |
*
* @param {Image_Export_Summary_Prefix_ScenaristInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_summary_prefix_scenarist = /** @type {((inputs: Image_Export_Summary_Prefix_ScenaristInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Summary_Prefix_ScenaristInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Prefixe : ${i?.prefix}.0001.tif -> ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Praefix: ${i?.prefix}.0001.tif -> ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Prefisso: ${i?.prefix}.0001.tif -> ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Префикс: ${i?.prefix}.0001.tif → ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Prefijo: ${i?.prefix}.0001.tif -> ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`前缀：${i?.prefix}.0001.tif → ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プレフィックス: ${i?.prefix}.0001.tif → ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`उपसर्ग: ${i?.prefix}.0001.tif → ${i?.prefix}.${i?.lastIndex}.tif`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Prefixo: ${i?.prefix}.0001.tif -> ${i?.prefix}.${i?.lastIndex}.tif`)
	return /** @type {LocalizedString} */ (`Prefix: ${i?.prefix}.0001.tif → ${i?.prefix}.${i?.lastIndex}.tif`)
});